import React from "react"

import { Floor } from "shared/types/Floor"
import { DragSource } from "shared/types/drag-and-drop/DragSource"
import { DropTarget } from "shared/types/drag-and-drop/DropTarget"

import { ProjectPageFloorTab } from "./ProjectPageFloorTab"
import { useFloorTabModel } from "./model/useFloorTabModel"

export interface FloorTabRendererProps {
  projectID: string
  floor: Floor
  index: number
  ariaControls?: string
  onSelectFloor: (floorID: string, event?: React.MouseEvent) => void
  onDrop?: (dragSource: DragSource, dropTarget: DropTarget) => void
  truncationThreshold?: number
}

export const ProjectPageFloorTabConnector = React.memo(
  (props: FloorTabRendererProps) => {
    const { handlers, onOpenDetails } = useFloorTabModel(props)
    return (
      <ProjectPageFloorTab
        floor={props.floor}
        index={props.index}
        ariaControls={props.ariaControls}
        onDrop={props.onDrop}
        truncationThreshold={props.truncationThreshold}
        handlers={handlers}
        onOpenDetails={onOpenDetails}
      />
    )
  }
)

ProjectPageFloorTabConnector.displayName = "ProjectPageFloorTabConnector"
